






























import Vue from 'vue'
import Component from 'vue-class-component'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

@Component({
  components: {}
})
class NetworkStatusHelperComponents10DigitalCurrencyAlternativeResourceItem extends Vue {

  projectName: string = projectVariables.projectName
  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenStatistics: number = 0
}

export default NetworkStatusHelperComponents10DigitalCurrencyAlternativeResourceItem

